import { render, staticRenderFns } from "./Resultat.vue?vue&type=template&id=9daae224&"
import script from "./Resultat.vue?vue&type=script&lang=js&"
export * from "./Resultat.vue?vue&type=script&lang=js&"
import style0 from "./Resultat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports